import React, { useState, useRef, useEffect } from "react";
import cn from "classnames";
import styles from "./Settings.module.sass";
import TooltipGlodal from "../../components/TooltipGlodal";
import Dropdown from "../../components/Dropdown";
import ProfileInformation from "./ProfileInformation";
import Login from "./Login";
import { getCurrentStudentInfo, updateCurrentUser } from "../../services/account.service";

const Settings = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formChanged, setFormChanged] = useState(false);
  const [userFormData, setUserFormData] = useState({name: ''});
  const [message, setMessage] = useState({type: '', text: ''});

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const data = await getCurrentStudentInfo();
        setUserData(data);
        if (data && data.user) {
          setUserFormData({
            name: data.user.name || ''
          });
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données utilisateur:", error);
        setMessage({type: 'error', text: 'Erreur lors de la récupération des données'});
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);
  
  const handleProfileFormChange = (formData) => {
    setUserFormData(formData);
    setFormChanged(true);
  };

  const navigation = [
    {
      title: "Informations du profil",
      action: () =>
        scrollToProfile.current.scrollIntoView({ behavior: "smooth" }),
    },
    {
      title: "Mot de passe",
      action: () =>
        scrollToLogin.current.scrollIntoView({ behavior: "smooth" }),
    },
  ];
  const options = [];
  navigation.map((x) => options.push(x.title));
  const [activeTab, setActiveTab] = useState(options[0]);

  const [activeIndex, setActiveIndex] = useState(0);
  const scrollToProfile = useRef(null);
  const scrollToLogin = useRef(null);

  const handleClick = (x, index) => {
    setActiveIndex(index);
    x.action();
  };
  return (
    <>
      <div className={styles.settings}>
        <div className={styles.menu}>
          {navigation.map((x, index) => (
            <button
              className={cn(styles.button, {
                [styles.active]: activeIndex === index,
              })}
              key={index}
              onClick={() => handleClick(x, index)}
            >
              {x.title}
            </button>
          ))}
        </div>
        <div className={styles.wrapper}>
          <Dropdown
            className={styles.dropdown}
            classDropdownHead={styles.dropdownHead}
            value={activeTab}
            setValue={setActiveTab}
            options={options}
          />
          <div className={styles.list}>
            <div
              className={cn(styles.item, {
                [styles.active]: activeTab === options[0],
              })}
            >
              <div className={styles.anchor} ref={scrollToProfile}></div>
              <ProfileInformation 
                userData={userData} 
                loading={loading} 
                formData={userFormData}
                onFormChange={handleProfileFormChange}
              />
            </div>
            <div
              className={cn(styles.item, {
                [styles.active]: activeTab === options[1],
              })}
            >
              <div className={styles.anchor} ref={scrollToLogin}></div>
              <Login userData={userData} loading={loading} />
            </div>
          </div>
          {message.text && (
            <div className={cn(styles.message, {
              [styles.error]: message.type === 'error',
              [styles.success]: message.type === 'success'
            })}>
              {message.text}
            </div>
          )}
        </div>
      </div>
      <TooltipGlodal />
    </>
  );
};

export default Settings;
